<div class="custom-tag-text">{{ text }}</div>